/** InsCoder 2026-02-25 B + Custom PDP Product Tabs Logic **/
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.cust-pdp-product-tabs');
  
  sections.forEach(section => {
    const tabs = section.querySelectorAll('.cust-pdp-product-tabs_tab_title');
    const contents = section.querySelectorAll('.cust-pdp-product-tabs_tab_content');
    
    if (tabs.length === 0) return;
    
    // Activate first tab by default if none active
    if (!section.querySelector('.cust-pdp-product-tabs_tab_title.is-active')) {
      tabs[0].classList.add('is-active');
      if (contents[0]) contents[0].classList.add('is-active');
    }
    
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        // Deactivate all
        tabs.forEach(t => t.classList.remove('is-active'));
        contents.forEach(c => c.classList.remove('is-active'));
        
        // Activate current
        tab.classList.add('is-active');
        if (contents[index]) {
          contents[index].classList.add('is-active');
        }
      });
    });
  });
});
/** InsCoder 2026-02-25 E + Custom PDP Product Tabs Logic **/
